import { render, staticRenderFns } from "./ButtonNotAllowed.vue?vue&type=template&id=bd12b5ea&"
import script from "./ButtonNotAllowed.vue?vue&type=script&lang=js&"
export * from "./ButtonNotAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports